module.exports = __webpack_public_path__ + "static/img/ability-img2.1ecf716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/ability-img2.png
// module id = TRJG
// module chunks = 2